export function noOpAction() {
  return {
    type: 'NO_OP',
  };
}
